import { faAlignRight } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import Toolbar from 'react-big-calendar/lib/Toolbar';
import InlineSVG from 'react-inlinesvg';
import arrowIcon from '../../../assets/svg/arrow.svg';


import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Input, Label, Table
} from 'reactstrap';
import { v4 } from 'uuid';
import { Calendar as MiniCalendar } from 'react-date-range';
import * as locales from "react-date-range/dist/locale";
import { DOMAINS } from '../../../constants';
import moment from 'moment';
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import infoIconV2 from "../../../assets/svg/link-new-tab.svg";
import Isvg from "react-inlinesvg";

import { Tooltip } from '@material-ui/core';
import { withStyles, makeStyles } from "@material-ui/core/styles";

const InfoTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#3a3f56",
        color: "#fff",
        boxShadow: theme.shadows[1],
        fontSize: 14
    }
}))(Tooltip);

/**
* React Big Calendar custom toolbar
* @author   Stefan Pantic
*/
export default class CalendarToolbar extends Toolbar {
    constructor(props) {
        super(props);
        this.state = {
            searchId: v4(),
            showCalendar: false,
        };
        this.buttonGroupRef = React.createRef();
    }

    onMouseDown = (e) => {
        if (this.state.showCalendar && this.buttonGroupRef.current && !this.buttonGroupRef.current.contains(e.target)) {
            this.setState({ showCalendar: false });
        }
    }

    getLocale = () => {
        let locale = null;
        if (typeof window !== "undefined" && window._lang) {
            if (window._lang == "en") {
                locale = locales.enGB;
            } else {
                let domen = window.location.origin;
                let country = DOMAINS.find((item) => item.domen == domen)?.country;
                if (country == "sweden") {
                    locale = locales.sv;
                } else if (country == "denmark") {
                    locale = locales.da;
                } else if (country == "gr") {
                    locale = locales.el;
                } else if (country == "es") {
                    locale = locales.es;
                } else if (country == "ch") {
                    locale = locales.de;
                } else {
                    locale = locales.enGB;
                }
            }
        }
        return locale;
    }

    componentDidMount() {
        if (this.props.isSearching === true) {
            const el = document.getElementById(this.state.searchId);
            if (el) el.focus();
        }
        const view = this.props.view;

        document.addEventListener('mousedown', this.onMouseDown);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.showCalendar && prevState.showCalendar != this.state.showCalendar) {
            this.calculateWeekNumbersCalendar();
        }



    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onMouseDown);
    }

    clearCustomElements = () => {
        if (typeof window === 'undefined') return;
        let elementsForRemove = document.getElementsByClassName("rdrWeekDayWeekNumberLabel");
        while (elementsForRemove.length > 0) {
            elementsForRemove[0].parentNode.removeChild(elementsForRemove[0]);
        }
        elementsForRemove = document.getElementsByClassName("rdrWeekNumber");
        while (elementsForRemove.length > 0) {
            elementsForRemove[0].parentNode.removeChild(elementsForRemove[0]);
        }
    }
    calculateWeekNumberByDate = (dateStr) => {
        if (dateStr && dateStr !== NaN) {
            let date = new Date(dateStr);
            date.setHours(12, 0, 0, 0);
            date.setDate(date.getDate() - 1);
            const m = moment(date);
            const week = m.week();
            return week && week !== NaN ? week : null;
        } else {
            return null;
        }
    }

    calculateWeekNumbersCalendar = (number = 0) => {
        if (this.state.showCalendar) {
            if (typeof window === 'undefined') return;

            this.clearCustomElements();

            const weekDays = document.getElementsByClassName("rdrWeekDays");
            const days = document.getElementsByClassName("rdrDays");
            const newArray = days?.[0]?.children ?? [];

            if (this.dateArr?.length === newArray.length && newArray.length > 0) {
                if (weekDays) {
                    for (let i = 0; i < weekDays.length; i++) {
                        let weekNumber = document.createElement("span");
                        weekNumber.className = "rdrWeekDayWeekNumberLabel";
                        weekNumber.innerHTML = `v`.translate(this.props.lang);
                        weekDays[i].insertBefore(weekNumber, weekDays[i].childNodes[0]);
                    }
                    let rdrWeekDay = document.getElementsByClassName("rdrWeekDay");
                    for (let i = 0; i < rdrWeekDay?.length; i++) {
                        rdrWeekDay[i]?.style?.setProperty("flex-basis", "calc(100% / 8)", "important");
                    }
                }

                if (newArray.length > 0) {

                    for (let i = 0; i < newArray.length; i++) {
                        if (i === 0 || i % 8 === 0) {
                            let element = document.createElement("div");
                            element.className = "rdrWeekNumber";
                            element.innerHTML = this.calculateWeekNumberByDate(this.dateArr[i]) ?? '';
                            days?.[0]?.insertBefore?.(element, newArray[i]);
                        }
                    }
                    let rdrDay = document.getElementsByClassName("rdrDay");
                    for (let i = 0; i < rdrDay?.length; i++) {
                        rdrDay[i]?.style?.setProperty("width", "calc(100% / 8)", "important");
                    }
                }
            } else {
                if (number > 10) return;
                setTimeout(() => {
                    this.calculateWeekNumbersCalendar(number + 1);
                }, 20 * number + 10);
            }
        }
    }

    abbreviateMonthWords = (label) => {
        const words = label.match(/\p{L}+/gu) || [];
        const seen = new Set();
        for (const w of words) {
            const key = w.normalize('NFKD').replace(/\p{Diacritic}/gu, '').toLowerCase().slice(0, 3);
            if (key) seen.add(key);
            if (seen.size === 2) break;

        }
        if (seen.size < 2) return label;

        return label.replace(/\p{L}+/gu, w =>
            seen.has(w.normalize('NFKD').replace(/\p{Diacritic}/gu, '').toLowerCase().slice(0, 3)) ? w.slice(0, 3) : w
        );


    }
    render() {
        const placeholder = 'Type text...'.translate(this.props.lang);
        const locale = this.getLocale();
        const calendarDate = ['agenda', 'day'].includes(this.props.view) && this.props.date ? new Date(this.props.date) : new Date();

        const humanReadableView = {
            day: 'Day'?.translate(this.props.lang),
            work_week: 'Work week'?.translate(this.props.lang),
            week: 'Week'?.translate(this.props.lang),
            month: 'Month'?.translate(this.props.lang),
            agenda: 'Agenda'?.translate(this.props.lang)
        }[this.props.view];
        const labelStyle = this.props.view === 'week' || this.props.view === 'work_week' ? { maxWidth: 170 } : {}

        return (
            <div className="rbc-container">
                {this.props.hideSearch ? null : <div className='rbc-search-container'>
                    <Input
                        id={this.state.searchId}
                        type='search'
                        name='search'
                        placeholder={placeholder}
                        value={this.props.filterV2}
                        onChange={(e) => { const val = e.target.value; this.props.onSearchChange?.(val); }}
                        onBlur={this.props.onSearchBlur}
                        onKeyDown={(e) => {
                            if (e?.key === 'Enter') {
                                this.props.onSearch?.(humanReadableView + ': ' + this.props.label);
                            }
                        }}
                    />
                    <Button
                        type='button'
                        color='primary'
                        className='search-mob-calendar-button'
                        size='sm'
                        onClick={() => {
                            if (this.props.filterV2?.trim?.() === '') return;
                            this.props.onSearch?.(humanReadableView + ': ' + this.props.label);
                        }}
                        disabled={this.props.filterV2?.trim?.() === ''}
                    >
                        {'Search'.translate(this.props.lang)}
                    </Button>
                    {/* <div className='webboking-settings-section-title-wrap'>
                        <div className='info'>

                            <div className="info-text">{'Show information about national holidays and/or important dates for the entire clinic in all staff calendars. Holidays and clinic specific dates are highlighted in the calendar, but clinicians can still schedule on these dates'.translate(this.props.lang)}</div>
                        </div>
                    </div> */}
                    <InfoTooltip title={'Search is only applied to the current view (e.g. Day, Week or Month). Switch views to search in a different timeframe.'.translate(this.props.lang)} placement="top-start" >
                        <div>
                            <Isvg src={infoIconV2} />
                        </div>
                    </InfoTooltip>

                </div>}

                {
                    this.props.showFromTo ?
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                            <div className="rbc-search-counter-container">
                                <button
                                    type='button'
                                    onClick={this.props.onSearchPrev}
                                    disabled={this.props.disabledBack}
                                    className='rbc-search-counter-button-left'
                                >
                                    <InlineSVG src={arrowIcon} />
                                </button>
                                <p>
                                    {this.props.searchItemNumber + 1} / {this.props.searchItemNumberTotal}
                                </p>
                                <button
                                    type='button'
                                    onClick={this.props.onSearchNext}
                                    disabled={this.props.disabledForward}
                                    className='rbc-search-counter-button-right'
                                >
                                    <InlineSVG src={arrowIcon} />
                                </button>
                            </div>
                            {
                                this.props.searchText ?
                                    <p>
                                        {this.props.searchText}
                                    </p>
                                    :
                                    null
                            }
                        </div>
                        :
                        null
                }

                {typeof window != 'undefined' && window.innerWidth < 768 ?
                    <div className="rbc-btn-group">
                    </div >
                    :
                    <div>
                        <div className="rbc-btn-group">
                            {
                                this.props.hideDay ?
                                    null
                                    :
                                    <Button type="button" style={{ margin: 1 }} onClick={this.view.bind(null, 'day')}>{'Day'.translate(this.props.lang)}</Button>

                            }
                            {
                                this.props.hideWorkWeek ?
                                    null
                                    :
                                    <Button type="button" style={{ margin: 1 }} onClick={this.view.bind(null, 'work_week')}>{'Work week'.translate(this.props.lang)}</Button>
                            }
                            {
                                this.props.hideWeek ?
                                    null
                                    :
                                    <Button type="button" style={{ margin: 1 }} onClick={this.view.bind(null, 'week')}>{'Week'.translate(this.props.lang)}</Button>

                            }
                            {
                                this.props.hideDay && this.props.hideWeek && this.props.hideWorkWeek ?
                                    null
                                    :
                                    <Button type="button" style={{ margin: 1 }} onClick={this.view.bind(null, 'month')}>{'Month'.translate(this.props.lang)}</Button>

                            }
                        </div >
                        <div className="rbc-btn-group">
                            {
                                this.props.hideAgenda ?
                                    null
                                    :
                                    <Button type="button" style={{ margin: 2 }} onClick={this.view.bind(null, 'agenda')}> {'Agenda'.translate(this.props.lang)}</Button>
                            }
                        </div>
                    </div>
                }

                {/* {typeof window != 'undefined' && window.innerWidth < 768 ?
                    null
                    :
                    <div className="rbc-btn-group">
                        {
                            this.props.hideAgenda ?
                                null
                                :
                                <Button type="button" style={{ margin: 2 }} onClick={this.view.bind(null, 'agenda')}> {'Agenda'.translate(this.props.lang)}</Button>
                        }
                    </div>
                } */}

                <div className="rbc-btn-group rbc-gray relative" style={{ display: 'flex' }} ref={this.buttonGroupRef} >
                    <Button type="button" style={{ backgroundColor: "rgb(58, 63, 86) " }} onClick={() => {
                        const currentDate = new Date();
                        if (this.props.daybookSelectToday) {
                            this.props.daybookSelectToday(currentDate);
                            return;
                        }
                        const date = new Date(this.props.day.getFullYear(), this.props.day.getMonth(), this.props.day.getDate());

                        if (currentDate.getFullYear() === date.getFullYear() && currentDate.getMonth() === date.getMonth() && currentDate.getDate() === date.getDate()) {
                            this.props.onView('day');
                        } else {
                            this.props.onNavigate('TODAY');
                        }
                    }}>{'Today'.translate(this.props.lang)}</Button>

                    <Button type="button" style={{ zIndex: 1 }} className={'rbc-first-button'} onClick={() => this.navigate('PREV')}>{'Previous'.translate(this.props.lang)}</Button>
                    <Label style={this.props.onMiniCalendarChange ? { cursor: 'pointer', ...labelStyle } : { ...labelStyle }} onClick={() => {
                        this.setState(prev => ({ ...prev, showCalendar: !prev.showCalendar }));
                    }} className="rbc-toolbar-label toolbar-label-small-screen">{this.abbreviateMonthWords(this.props.label)}</Label>
                    <Button style={{ zIndex: 1 }} className='rbc-last-button' type="button" onClick={() => this.navigate('NEXT')}>{'Next'.translate(this.props.lang)}</Button>

                    {this.state.showCalendar && this.props.onMiniCalendarChange ? <div className='calendar-date-picker-wrap rbc-mini-calendar-container'>
                        <MiniCalendar
                            date={calendarDate}
                            locale={locale}
                            onChange={(date) => {
                                this.setState({ showCalendar: false }, () => {
                                    this.props.onMiniCalendarChange?.(date);
                                });
                            }}
                            dayContentRenderer={(date) => {
                                if (date) {
                                    let dateStr = moment.unix(new Date(date).getTime() / 1000).format('MM/DD/YYYY');
                                    let dateArr = this.dateArr?.length ? this.dateArr : [];
                                    if (!dateArr.includes(dateStr)) {
                                        dateArr.push(dateStr);
                                        this.dateArr = dateArr;
                                    }
                                }
                            }}

                            onShownDateChange={(date) => {
                                this.dateArr = [];
                                this.calculateWeekNumbersCalendar();
                            }}
                        />
                    </div> : null}
                </div>


            </div>
        );
    }
}